.pes-document-icon,
.pes-document-icon svg {
  display: inline-block;
  width: 14px;
  height: 20px;
}

@media screen and (max-width: 719px) {
  .pes-document-icon,
.pes-document-icon svg {
    width: 10px;
    height: 15px;
  }
}